import { Field, ImageField, LinkField } from '@sitecore-content-sdk/nextjs';

// Mirrors ContentGrid.graphql.ts but targets the `TimedReleaseOverride` template.
// Notes:
// - The GraphQL type name (`TimedReleaseOverride`) is derived from the Sitecore
//   template name with spaces removed.
// - The `URL` field collides with Edge's built-in `url` field, so it must be
//   queried via `field(name: "URL")` and aliased.
// - `releaseDate` is the additional field this template has over ContentOverride.
const TimedReleaseOverrideQuery = /** GQL */ `query($datasource: String!, $language: String!){
    root: item(path: $datasource, language: $language) {
    children(first:500) {      
        results {
          ... on TimedReleaseOverride {
            overrideContent {
              jsonValue
            }
            title {
              jsonValue
            }
            removeTitleLink {
              jsonValue
            }
            image {
              jsonValue
            }
            tag {
              jsonValue
            }
            description {
              jsonValue
            }
            url: field(name: "URL") {
              jsonValue
            }
            ctaText {
              jsonValue
            }
            releaseDate {
              jsonValue
            }
          }
        }
      }
    }
  }
  
`;

export default TimedReleaseOverrideQuery;

export type TimedReleaseOverrideQueryResult = {
  root?: {
    children?: {
      results?: TimedReleaseOverrideNode[];
    };
  };
};

export type TimedReleaseOverrideNode = {
  overrideContent?: {
    jsonValue: Field<string>;
  };
  title?: {
    jsonValue: Field<string>;
  };
  removeTitleLink?: {
    jsonValue: Field<boolean>;
  };
  image?: {
    jsonValue: ImageField;
  };
  tag?: {
    jsonValue: Field<string>;
  };
  description?: {
    jsonValue: Field<string>;
  };
  url?: {
    jsonValue: LinkField;
  };
  ctaText?: {
    jsonValue: Field<string>;
  };
  releaseDate?: {
    jsonValue: Field<string>;
  };
};
